import React, { Component } from "react";
import Predefine_2_Polo_FullS_Cricket from "../components/Predefine_2_Polo_FullS_Cricket/Predefine_2_Polo_FullS_Cricket";

export class Predefine_2_Polo_FullS_CricketPage extends Component {
  render() {
    return <Predefine_2_Polo_FullS_Cricket />;
  }
}

export default Predefine_2_Polo_FullS_CricketPage;
